// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader-0dad3401","lds-dual-ring":"lds-dual-ring-33fafd0d","ldsDualRing":"lds-dual-ring-33fafd0d","small":"small-3606546a"};